import axios from 'axios';
import qs from 'qs';

export const revokeToken = async (refreshToken, cognitoDomain, clientId) => {
  const data = qs.stringify({
    'client_id': clientId,
    'token': refreshToken
  });
  const requestOptions = {
    url: cognitoDomain + '/oauth2/revoke',
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    data: data
  };
  return axios(requestOptions);
};